import template from './radniNalogEdit.html';
import swal from 'sweetalert';

class RadniNalogEditController {
    constructor(DS, AppConfiguration, $state, logger) {
        this.$state = $state;
        this.logger = logger;
        this.Model = DS.definitions['RadniNalog'];
        this.view = AppConfiguration().getViewByEntityAndType('RadniNalog', 'EditView');
    }

    $onInit() {
        this.pageTitle = `Izmjena radnog naloga ${this.item.broj_naloga}`;
        this.pageDesc = 'Izmjena općih podataka radnog naloga';
        this.fields = this.view.fields();
        this.model = Object.assign({}, this.item, { stavke: [], veze: [], faze: [] });
    }

    submit(item) {
        const previousWindowKeyDown = window.onkeydown;
        this.Model.update(item.id, item)
            .then(response => {
                swal(
                    {
                        title: 'Zahvaljujemo',
                        text: 'Podaci su uspješno ažurirani',
                        type: 'success',
                        closeOnConfirme: true
                    },
                    () => {
                        window.onkeydown = previousWindowKeyDown;
                        this.$state.go('radniNalog.details', { id: response.id });
                    }
                );
            })
            .catch(error => {
                this.logger.error('Upsss', error.data);
            });
    }
}

RadniNalogEditController.$inject = ['DS', 'AppConfiguration', '$state', 'logger'];

const RadniNalogEditComponent = {
    restrict: 'E',
    templateUrl: template,
    controller: RadniNalogEditController,
    controllerAs: 'vm',
    bindings: {
        item: '<'
    }
};

export { RadniNalogEditComponent };
export { RadniNalogEditController };



// WEBPACK FOOTER //
// ./app/components/radniNalog/radniNalogEdit.component.js